import {
  CalendarDaysIcon,
  ClipboardListIcon,
  Mail,
  MapPinIcon,
  PhoneCallIcon,
} from 'assets/icons';

// A task has a single kind now (`todo`): a rendez-vous is created in the
// planning, a call in the call list. The old types stay known so that a task
// stored with one still reads, and so that its history can name them: their
// icon, and the colour of their badge (components/badge, the sector tags of
// jobbiz_app_v2). Labels live in the locales (taskTypes).
export const TASK_TYPE = 'todo';
export const TASK_TYPES = {
  todo: { icon: ClipboardListIcon, badge: 'SECTOR_GREY' },
  call: { icon: PhoneCallIcon, badge: 'SECTOR_BLUE' },
  email: { icon: Mail, badge: 'SECTOR_ORANGE' },
  visit: { icon: MapPinIcon, badge: 'SECTOR_GREEN' },
  meeting: { icon: CalendarDaysIcon, badge: 'SECTOR_PURPLE' },
};

export const taskTypeOf = (type) => TASK_TYPES[type] ?? TASK_TYPES.todo;

export const taskTypeLabel = (language, type) =>
  language.getValue(`taskTypes.${type in TASK_TYPES ? type : 'todo'}`, '');

// What a row of the task lists is: a task, or an appointment or a callback
// ticked on the home page. Labels: tasks.rowTask, rowAppointment, rowCallback.
export const ROW_KINDS = {
  task: { icon: ClipboardListIcon, badge: 'SECTOR_GREY', label: 'rowTask' },
  appointment: { icon: CalendarDaysIcon, badge: 'SECTOR_PURPLE', label: 'rowAppointment' },
  callback: { icon: PhoneCallIcon, badge: 'SECTOR_BLUE', label: 'rowCallback' },
};
export const rowKindOf = (kind) => ROW_KINDS[kind] ?? ROW_KINDS.task;
